import secureLocalStorage from "react-secure-storage";
import { useAuth } from "../../../context/auth";
import { useEffect, useMemo, useState } from "react";
import { DeleteEmbalagens, GetEmbalagens, PostEmbalagens } from "../../../data/services";
import ConfirmDeleteModal from "../components/ConfirmDeleteModal";
import { toast } from "react-toastify";
import AdicionarEmbalagens from "./AdicionarEmbalagens";

const AdminEmbalagens = () => {
  const { user } = useAuth();
  const profile = user.profile;

  if (profile === "usuarioFornecedor") window.location.href = "/home";
  const token: any = secureLocalStorage.getItem("access_token");
  if (!token) {
    window.location.href = "/";
  }
  const UnidadeAdmin = "adminUnidade";
  const SuperAdmin = "superAdmin";
  const adm = profile === SuperAdmin || profile === UnidadeAdmin;

  const [embalagensOptions, setEmbalagensOptions] = useState<any>([]);
  const [openAdicionar, setOpenAdicionar] = useState(false);
  const [selectedEmbalagem, setSelectedEmbalagem] = useState<any>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    GetEmbalagens(setEmbalagensOptions);
  }, []);

  // Salvar e atualizar lista
  async function handleSaveEmbalagem(embalagem: { material: string, idMaterialSap: string }) {
    try {
      await PostEmbalagens(embalagem);
      GetEmbalagens(setEmbalagensOptions);
      setOpenAdicionar(false);
      return true;
    } catch (error) {
      console.error(error);
      return false;
    }
  }

  const handleConfirmDelete = async () => {
    try {
      await DeleteEmbalagens(selectedEmbalagem.idEmbalagem);
      toast.success("Embalagem deletada com sucesso!");
      setEmbalagensOptions((prev: any[]) =>
        prev.filter(
          (item) => item.idEmbalagem !== selectedEmbalagem.idEmbalagem
        )
      );
    } catch (error) {
      toast.error("Erro ao deletar embalagem.");
    } finally {
      toggleModal();
    }
  };

  const toggleModal = () => setIsModalOpen(!isModalOpen);

  const ListColumns = useMemo(() => {
    return (
      <>
        <td className="listProperty">Id</td>
        <td className="listProperty">material</td>
        <td className="listProperty">idMaterialSap</td>
        {adm && <td className="listProperty">Ações</td>}
      </>
    );
  }, []);

  const List = useMemo(() => {
    return (
      <>
        {embalagensOptions
          ?.sort(function (a: any, b: any) {
            if (a.name > b.name) {
              return 1;
            }
            if (a.name < b.name) {
              return -1;
            }
            return 0;
          })
          .map((item: any) => {
            return (
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  flexDirection: "column",
                  padding: 5,
                  borderBottom: "1px solid #dddddd",
                }}
              >
                <tr style={{ display: "flex", width: "100%" }}>
                  <td className="listTd">{item.idEmbalagem}</td>
                  <td className="listTd">{item.material}</td>
                  <td className="listTd">{item.idMaterialSap}</td>
                  {adm && (
                    <div style={{ display: "flex", flex: 1, marginLeft: 3 }}>
                      {/* <button
                          className="editBtn"
                          onClick={() => {
                            setOpen((prev: any) => ({
                              ...prev,
                              open: true,
                              method: "putch",
                            }));
                            setInfo(item);
                          }}
                        >
                          Editar
                        </button> */}
                      <button
                        className="deleteUserBtn"
                        onClick={() => {
                          setSelectedEmbalagem(item);
                          setIsModalOpen(true);
                        }}
                      >
                        Deletar
                      </button>
                    </div>
                  )}
                </tr>
              </div>
            );
          })}
      </>
    );
  }, [embalagensOptions]);

  return (
    <div>
      <div className="modalSignUp">
        <div className="content-header-button-and-title">
          <h1> Embalagens </h1>

          {adm && (
            <button
              className="BtnClean"
               onClick={() => setOpenAdicionar(true)}
            >
              Adicionar
            </button>
          )}
        </div>

        <div className="contentList">{ListColumns}</div>
        <div className="content">
          <div className="containerListInfo">
            {embalagensOptions.length > 0 ? (
              <>{List}</>
            ) : (
              <div style={{ textAlign: "center" }}>
                <h1 style={{ margin: "35px 0", fontSize: 28 }}>
                  Não há registros aqui
                </h1>
              </div>
            )}
          </div>
        </div>
      </div>
      
      {openAdicionar && (
        <AdicionarEmbalagens
          onSave={handleSaveEmbalagem}
          onCancel={() => setOpenAdicionar(false)}
        />
      )}

      <ConfirmDeleteModal
        isOpen={isModalOpen}
        toggle={toggleModal}
        onConfirm={handleConfirmDelete}
        itemName={selectedEmbalagem?.material ?? ""}
      />
    </div>
  );
};
export default AdminEmbalagens;
